import { clsx } from "clsx";
import { IReason } from "./ReportPopup";
import "./styles/ReportStepOne.scss";

interface IProps {
  reportReasons: IReason[];
  reportReason: IReason;
  setReportReason: (reason: IReason) => void;
  nextStep: () => void;
}

export const ReportStepOne = (props: IProps) => {
  const { reportReasons, reportReason, setReportReason } = props;

  const isSelected = (value: number, selected: IReason) => {
    if (value === selected.value) {
      return true;
    } else {
      return false;
    }
  };

  return (
    <div className="ReportStepOne">
      <p className="ReportStepOne-Text">Why are you reporting this GIF?</p>
      <ul className="ReportStepOne-List">
        {reportReasons.map(el => (
          <li className="ReportStepOne-ListItem" key={el.value}>
            <button
              onClick={() => setReportReason(el)}
              className={
                clsx(
                  "ReportStepOne-ItemButton",
                  { "ReportStepOne-ItemButton_isActive": isSelected(el.value, reportReason) }
                )
              }
            >
              <span>{el.text}</span>
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
};
